import{a as t}from"./chunk-DMS2IT2J.js";import{a}from"./chunk-6JNQ7TTS.js";import{b as m,c as r}from"./chunk-DM3D2J44.js";import{m as s}from"./chunk-HBP5N4FR.js";s();a();var i=o=>t.dispatch(m(o)).payload,C=o=>t.dispatch(r(o));export{i as a,C as b};
//# sourceMappingURL=chunk-D65RV2TG.js.map
